module.exports = __webpack_public_path__ + "static/media/slide-3.b11dc45e.webp";